import React, { Component } from "react";
// import { bindActionCreators } from "redux";
// import withRedux from "next-redux-wrapper";
// import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
// import Store from "store";
// import { fetchCategories } from "store/posts/actions";
import NProgress from "components/NProgress";
// import Header from '../container/DefaultLayout/header';
import { withStyles } from '@material-ui/core/styles';
// import Footer from "/container/DefaultLayout/footer.js"
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ReactPixel from 'react-facebook-pixel';
// import Headroom from "react-headroom";
// import TagManager from 'react-gtm-module';
import SeoMeta from '/components/seoMeta';
// import YouTubePlayer from 'react-player/lib/players/YouTube';
import ClapprPlayer from '../components/Clappr/ClapprPlayer';
import ReactHtmlParser from 'react-html-parser';
import { AdSlot, DFPManager } from 'react-dfp';

import {
  isMobile
} from "react-device-detect";

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

const styles = theme => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing.unit * 2,
      color: theme.palette.text.secondary,
      [theme.breakpoints.up('sm')]: {
        margin: '50px 0px'
      },
    },
    aboutUsTitle:{
      color: theme.palette.primary.main,
      textAlign: 'center',
      fontWeight: 'bold',
      marginBottom: 18,
      fontSize: '1.5em'
    },
    aboutUsPara:{
      textIndent: 50
    },
    videoWrapper: {
      minWidth: "330px",
      float: 'none',
      margin: '0 0 12px 0',
      [theme.breakpoints.up('md')]: {
        width: "390px",
        margin: '0 12px 4px 0',
        height: '220px',
        float: 'left',
      },
    },
    innityAd: {
        padding : 60,
        textAlign: 'center'
    }
  });

class AboutUs extends Component {
  constructor(props){
    super(props);
    this.state = {
       ssrDone: false,
    };
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onVideoLoad = this.onVideoLoad.bind(this);
  }

  onPlay() {
    console.log('onPlay');
  }
  onPause() {
    console.log('onPause');
  }
  onVideoLoad() {
    console.log('onVideoLoad');
  }

  render() {
    const { classes, isServer } = this.props;
    const ssrDone = this.state.ssrDone;
    const videoAboutUs = {
      "title": "Duwun - The biggest online media in Myanmar within two years",
      "posters": {
        "social": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-social.jpg",
        "thumb": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-thumb.jpg",
        "thumb_mobile": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-thumb_mobile.jpg",
        "next_video_teaser": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-next_video_teaser.jpg",
        "mobile_next_video_teaser": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-mobile_next_video_teaser.jpg",
        "video_section_teaser": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-video_section_teaser.jpg",
        "mobile_video_section_teaser": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-mobile_video_section_teaser.jpg"
      },
      "slug": "duwun-the-biggest-online-media-in-myanmar-within-two-yearsmp4-id892",
      "description": "<div>Duwun started in December 2015 as a young media start-up backed by Ringier and Information Matrix. We came to the media space with millennial focused lifestyle and entertainment coverage which got strong supports from Myanmar millennials.<br><br>Duwun reached 1 million social followers within first six months and kept growing at an exponential rate. The next million only took 2 months.<br><br>By early 2017, the trend changed. Our millennials don't want to read long text anymore. They want interactivity. So we launched Duwun TV to keep the milleniels happy with cool video content.<br><br>Later on, we started expanding our reach by launching more community focus pages such as Duwun Sports for sports, Cele Yatkwat for celebrity, Duwun Tech for startups and disruptive tech, Madi for women empowerment and Ayathar for Foodie culture creating much quicker and more in-depth coverage.<br><br>Now Duwun stands at a total of 10 million combined social media followers generating 13 million pageviews a month and 50 million video views a month making us the No.1 online media in Myanmar in terms of readership.<br><br>We love your support and we will keep growing further.</div>",
      "p_date": "2017-05-30T23:28:47Z",
      "duration": "83",
      "jwplayer": true,
      "jwplayer_id": "6WEvvopZ",
      "video_url": "https://dmbf27t3xv7sf.cloudfront.net/converted/nxwYeVSZ9V/549.m3u8",
      "jw_media_id": "mI0US4qb",
      "media_id": "nxwYeVSZ9V",
      "published_date": {
        "date": "2017-05-30T23:28:47Z"
      },
      "author": {
        "name": "Ko Aung",
        "email": "aungmyo.linn@duwun.com.mm"
      },
      "created_at": {
        "date": "2020-04-12 23:27:40.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "updated_at": {
        "date": "2020-04-12 23:33:05.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "tags": [],
      "categories": [],
      "visitors": 1,
      "ga": {
      "ga:pageviews": "0"
      },
      "ad_tag": null,
      "no_ads": false
    }
    return (
      <div>
        <Head>
          <title>About Us</title>
        </Head>
        <SeoMeta
          url={`${process.env.BACKEND_URL}/about-us`}
          type="article"
          title='About Us'
          description="About us"
          image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
          section='about us'
          keywords='about us'
        />
        <NProgress />
        <div className={classes.root}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={10} md={8}>
              <Paper className={classes.paper}>
                <Typography component="h1" variant="h5" className={classes.aboutUsTitle} gutterBottom>
                    About Us
                </Typography>
                {
                  !isServer && ssrDone &&
                  <div>
                    <div className={classes.videoWrapper}>
                      <ClapprPlayer
                      id="duwun-about-us-clappr-player"
                      width="100%"
                      height={isMobile ? "calc(100vw * 0.5625)" : "220px"}
                      autoPlay
                      poster={videoAboutUs.posters.social}
                      source={videoAboutUs.video_url}
                      onPlay={this.onPlay}
                      onPause={this.onPause}
                      onVideoLoad={this.onVideoLoad}
                      video={videoAboutUs}
                      />
                    </div>
                    <div>
                      {videoAboutUs.description && ReactHtmlParser(videoAboutUs.description)}
                    </div><br /><br />
                    <Typography component="h2" variant="h6" className={classes.aboutUsTitle} gutterBottom>
                    Who we are
                    </Typography>
                  </div>
                }

                {/* <YouTubePlayer
                  url={"https://youtu.be/NjcOX2dnXLo"}
                  controls
                  width="100%"
                  height={isMobile ? "200px" : "360px"}
                  playing
                  muted
                /> */}
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                    Duwun is a Joint-Venture Digital Media company between biggest media giants in Switzerland and Myanmar, Ringier AG and Information Matrix respectively.
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                    We strive to be the biggest digital media in Myanmar that locals go to get informed, entertained and connected. While we have access to wealth of international and local experiences from over 9,000 employees worldwide, we still adopt the innovation obsessed culture and structure of a tech company while at the same time where we will be able to connect deeply with our audience through locally-curated contents and videos worth
                    sharing with their friends, family and people who matter in their lives.
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                    Our news and entertainment teams serve millennial of highly engaged generation in Myanmar who will be only consuming more video and content across platforms, on mobile with our experienced engineering team
                    focused on giving the optimum user experience for readers.
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                    While our content and videos connect with people on a large scale, our events team who has been responsible behind Yangon's top hit events such as Spectrum Nightlife series, Duwun Talk, Urban Talent has played
                    a significant role in connecting people to each other.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
    componentDidMount () {
        // ************ start facebook pixel ***********

        if (!window.PX_INITIALIZED) {
            const advancedMatching = { em: '' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
            const options = {
                autoConfig: true, 	// set pixel's autoConfig
                debug: false, 		// enable logs
            };
            ReactPixel.init('548709379041005', advancedMatching, options);
            // ReactPixel.init('355678948310337', advancedMatching, options);
            window.PX_INITIALIZED = true
        }
        // ReactPixel.pageView(); 					// For tracking page view
        //  ReactPixel.track( event, data ) 		// For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
        //  ReactPixel.trackCustom( event, data ) 	// For tracking custom events
        // ************ end facebook pixel ***********
        this.setState({
            ssrDone: true,
        });
    }

    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }
}

export default withStyles(styles)(AboutUs);
